export const button = {
  add: {
    marginRight: '10px',
    position: 'absolute',
    right: '0px',
    marginTop:'5px'
  },
  delete : {
    backgroundColor: '#F44336',
    color: '#fff'
  },
  save : {
    background: '#1079DD',
    width: '100px'
  },
  logout : {
    background: '#FF0000',
    width: '100px'
  }
}

export const apps = {
  cardDiv : {
    display: 'inline-block',
    margin: '10px',
    cursor: 'pointer'
  },

  card : {
    width: '256px',
    height: '175px'
  },

  cardTitle : {
    alignItems: 'flex-start',
    color: '#000'
  }
}

export const appChannels = {
  cardDiv : {
    display: 'inline-block',
    margin: '10px'
  },

  card : {
    width: '256px',
    minHeight: '175px'
  },

  cardTitle : {
    alignItems: 'flex-start',
    color: '#fff',
    background: '#46B6AC'
  },

  cardText : {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },

  cardActions : {
    display: 'flex',
    boxSizing: 'border-box',
    alignItems: 'center'
  }
}

export const channelTypeSelector = {
  cardDiv: {
    display: 'inline-block',
    margin: '10px',
    cursor: 'pointer'
  },

  cardDiv_noclick: {
    display: 'inline-block',
    margin: '10px',
  },

  card: {
    width: '256px',
    minHeight: '175px'
  },

  cardTitle: {
    alignItems: 'flex-start',
    color: '#000'
  }
}

export const appSettings = {
  label: {
    color:'#627C8A',
    marginBottom:'5px',
    display:'block'
  },

  textField : {
    border:'1px solid #C5D4DC',
    height: '25px',
    width: '200px',
    marginBottom:'10px',
    padding: '3px'
  },

  errorTextField : {
    border: '3px solid #FF0000',
    background: '#FFEEEE',
    height: '25px',
    width: '200px',
    marginBottom:'10px',
    padding: '3px'
  },
}

export const account = {
  avatar: {
    backgroundColor: '#F5F5F5',
    border: '1px solid #DDDDDD',
    borderRadius: '50% 50% 50% 50%',
    padding: '4px',
    width: '50px',
    marginRight: '15px'
  },
  info : {
    marginLeft: '75px'
  },
}

export const channelPage = {
  label: {
    color:'#627C8A',
    width: '150px',
    display: 'inline-block',
    marginBottom:'15px'
  },

  textField: {
    border:'1px solid #C5D4DC',
    height: '25px',
    width: '100px',
    padding: '3px'
  },

  errorTextField : {
    border: '3px solid #FF0000',
    background: '#FFEEEE',
    height: '25px',
    width: '100px',
    padding: '3px'
  },

  checkbox : {

  }
}

export const infoPanel = {
  title: {
    color: '#aaa',
    margin: '10px',
    fontSize: '20px'
  },
  text: {
    color: '#aaa',
    margin: '0px 10px'
  }
}



// WEBPACK FOOTER //
// ./src/styles/styles.js